$(document).ready(function() {
    if ($('body').data('router-name') !== 'checktext') {
        return;
    }

    window.ajaxLoadRow.initialize('/admin/check-text/render', 10);
});
